import React from 'react';
import { MegaphoneIcon, BookOpenIcon, LightbulbIcon, ClockIcon, PlayIcon, UserIcon, PackageIcon, BookMarkedIcon, TimerIcon, RefreshCwIcon, PauseIcon, CheckCircleIcon } from 'lucide-react';
const RedBadge = ({
  label
}: {
  label: string;
}) => <span className="inline-flex items-center px-2 py-0.5 text-white text-xs font-bold rounded" style={{
  backgroundColor: '#CC0000'
}} data-id="element-2094" data-mp="36f5hknkpv2e5">
    {label}
  </span>;
export function Instructions() {
  return <div className="space-y-8 max-w-3xl" data-id="element-2095" data-mp="6y75bf9vcqxr">
      {/* 1. WELCOME BANNER */}
      <div className="rounded-xl px-6 py-5 text-white" style={{
      backgroundColor: '#4A2D8F'
    }} data-id="element-2096" data-mp="6zi7xbrkvsna">
        <h1 className="text-2xl font-extrabold tracking-tight mb-1" data-id="element-2097" data-mp="3tcgqlfii5iub">
          Welcome to Desert Sage Seminars!
        </h1>
        <p className="text-purple-200 text-sm" data-id="element-2098" data-mp="kvvqypbrg23v">
          Read these quick instructions before you start — it'll save you time.
        </p>
      </div>

      {/* Returning Students Alert */}
      <div className="flex items-start gap-3 rounded-xl border-2 border-amber-400 bg-amber-50 px-5 py-4" data-id="element-2099" data-mp="13w8zr07mvqkr">
        <MegaphoneIcon className="h-5 w-5 text-amber-500 flex-shrink-0 mt-0.5" data-id="element-2100" data-mp="yxz4kplwspz5" />
        <div data-id="element-2101" data-mp="1dmc1ppwqgev8">
          <p className="text-sm font-extrabold text-amber-800 uppercase tracking-wide mb-0.5" data-id="element-2102" data-mp="1dm28ltge5rlb">
            For Returning Students
          </p>
          <p className="text-sm text-amber-900 leading-relaxed" data-id="element-2103" data-mp="1mlyrtfk0hy8z">
            Please update your license expiration date in your{' '}
            <strong data-id="element-2104" data-mp="1il586ydlr5lw">Manage Profile</strong> folder on your Dashboard to clear
            the system for your <strong data-id="element-2105" data-mp="1wkemttm5trnr">NEW cycle</strong>.
          </p>
        </div>
      </div>

      {/* 2. WHERE TO FIND YOUR CLASSES */}
      <div data-id="element-2106" data-mp="1rmczuxlm5870">
        <div className="flex items-center gap-2 mb-4" data-id="element-2107" data-mp="1rluwzi4g3vq4">
          <BookOpenIcon className="h-5 w-5" style={{
          color: '#4A2D8F'
        }} data-id="element-2108" data-mp="25bzo2kl2lo0" />
          <h2 className="text-lg font-extrabold" style={{
          color: '#4A2D8F'
        }} data-id="element-2109" data-mp="3tdzmyo2dwiy7">
            Where to Find Your Classes After Purchase
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-2110" data-mp="22a7swn3rus50">
          {/* Card 1 */}
          <div className="rounded-xl overflow-hidden border border-slate-200 shadow-sm" data-id="element-2111" data-mp="26c2t1o9yuzh7">
            <div className="px-4 py-3 flex items-center gap-2" style={{
            backgroundColor: '#4A2D8F'
          }} data-id="element-2112" data-mp="2bacqy6n2se6i">
              <PackageIcon className="h-4 w-4 text-yellow-300 flex-shrink-0" data-id="element-2113" data-mp="2l5xxmi33a2ml" />
              <p className="text-white text-xs font-bold leading-tight" data-id="element-2114" data-mp="2pxpd9xkpinxy">
                SELECT YOUR OWN Package
                <span className="block font-normal text-purple-200" data-id="element-2115" data-mp="2tyhogwd532wv">
                  (3 or 6 classes)
                </span>
              </p>
            </div>
            <div className="bg-white px-4 py-4" data-id="element-2116" data-mp="33xqh9lw9qbhn">
              <ol className="space-y-2 text-sm text-slate-700" data-id="element-2117" data-mp="33yi86jex7l1l">
                <li className="flex gap-2" data-id="element-2118" data-mp="3e26u06egbch8">
                  <span className="flex-shrink-0 w-5 h-5 rounded-full text-white text-xs font-bold flex items-center justify-center" style={{
                  backgroundColor: '#4A2D8F'
                }} data-id="element-2119" data-mp="3e2ypzibync81">
                    1
                  </span>
                  <span data-id="element-2120" data-mp="3048u260vnil9">
                    Click <strong data-id="element-2121" data-mp="nagmuean13a">Available Classes</strong> folder
                  </span>
                </li>
                <li className="flex gap-2" data-id="element-2122" data-mp="3rsscvv3wnmf4">
                  <span className="flex-shrink-0 w-5 h-5 rounded-full text-white text-xs font-bold flex items-center justify-center" style={{
                  backgroundColor: '#4A2D8F'
                }} data-id="element-2123" data-mp="3rttyuumgltbm">
                    2
                  </span>
                  <span data-id="element-2124" data-mp="emjx7v6evx7s">Check the box to choose your class</span>
                </li>
                <li className="flex gap-2" data-id="element-2125" data-mp="ekfn2vhx61z2">
                  <span className="flex-shrink-0 w-5 h-5 rounded-full text-white text-xs font-bold flex items-center justify-center" style={{
                  backgroundColor: '#4A2D8F'
                }} data-id="element-2126" data-mp="3v9n6843exja9">
                    3
                  </span>
                  <span data-id="element-2127" data-mp="3qble6to0e9mn">
                    Click <strong data-id="element-2128" data-mp="3qcn1bwiaumkq">Enroll Me</strong> button
                  </span>
                </li>
                <li className="flex gap-2" data-id="element-2129" data-mp="hx38uzpgd86q">
                  <span className="flex-shrink-0 w-5 h-5 rounded-full text-white text-xs font-bold flex items-center justify-center" style={{
                  backgroundColor: '#4A2D8F'
                }} data-id="element-2130" data-mp="mucz2hko1nvm">
                    4
                  </span>
                  <span data-id="element-2131" data-mp="10t2wjybedpki">
                    Click <strong data-id="element-2132" data-mp="10s1irm2zyoz3">My Classes</strong> folder
                  </span>
                </li>
                <li className="flex gap-2" data-id="element-2133" data-mp="15mp6hiq6ffcm">
                  <span className="flex-shrink-0 w-5 h-5 rounded-full text-white text-xs font-bold flex items-center justify-center" style={{
                  backgroundColor: '#4A2D8F'
                }} data-id="element-2134" data-mp="2qa84ralge0er">
                    5
                  </span>
                  <span data-id="element-2135" data-mp="2v31dsanyfuwn">
                    Click the class <strong data-id="element-2136" data-mp="27c5mrfrbp3qg">Title</strong> to enter
                  </span>
                </li>
                <li className="flex gap-2" data-id="element-2137" data-mp="27dytsw5ulpyz">
                  <span className="flex-shrink-0 w-5 h-5 rounded-full text-white text-xs font-bold flex items-center justify-center" style={{
                  backgroundColor: '#4A2D8F'
                }} data-id="element-2138" data-mp="22e4611hddgi5">
                    6
                  </span>
                  <span data-id="element-2139" data-mp="3snxbvczfi1e7">
                    Click <RedBadge label="YOUR CLASS" data-id="element-2140" data-mp="3srbbwekmdyih" /> to begin
                  </span>
                </li>
              </ol>
            </div>
          </div>

          {/* Card 2 */}
          <div className="rounded-xl overflow-hidden border border-slate-200 shadow-sm" data-id="element-2141" data-mp="3uvoidfc54vss">
            <div className="px-4 py-3 flex items-center gap-2" style={{
            backgroundColor: '#E8A020'
          }} data-id="element-2142" data-mp="3lg1p7jrhlmb">
              <BookMarkedIcon className="h-4 w-4 text-white flex-shrink-0" data-id="element-2143" data-mp="dkf9knwpdd89" />
              <p className="text-white text-xs font-bold leading-tight" data-id="element-2144" data-mp="3c3m7kkm6k9qg">
                PRESET Package
                <span className="block font-normal text-yellow-100" data-id="element-2145" data-mp="3h1e1fk6dy5xa">
                  (6, 8, or 10 classes)
                </span>
              </p>
            </div>
            <div className="bg-white px-4 py-4" data-id="element-2146" data-mp="3lzflo8fjsbac">
              <ol className="space-y-2 text-sm text-slate-700" data-id="element-2147" data-mp="3qss6s8l0pzyc">
                <li className="flex gap-2" data-id="element-2148" data-mp="2tcuq0vs1hd0z">
                  <span className="flex-shrink-0 w-5 h-5 rounded-full text-white text-xs font-bold flex items-center justify-center" style={{
                  backgroundColor: '#E8A020'
                }} data-id="element-2149" data-mp="2tc37aljjj9s4">
                    1
                  </span>
                  <span data-id="element-2150" data-mp="1bcvfeezo6gpl">
                    Click <strong data-id="element-2151" data-mp="16fmzkl1zuori">My Classes</strong> folder
                  </span>
                </li>
                <li className="flex gap-2" data-id="element-2152" data-mp="11h24t15igxag">
                  <span className="flex-shrink-0 w-5 h-5 rounded-full text-white text-xs font-bold flex items-center justify-center" style={{
                  backgroundColor: '#E8A020'
                }} data-id="element-2153" data-mp="11gaadtnnh5lr">
                    2
                  </span>
                  <span data-id="element-2154" data-mp="nnays2qznvjh">
                    Click the class <strong data-id="element-2155" data-mp="iqu6cwcrav0l">Title</strong> to enter
                  </span>
                </li>
                <li className="flex gap-2" data-id="element-2156" data-mp="drr0j9oyckrk">
                  <span className="flex-shrink-0 w-5 h-5 rounded-full text-white text-xs font-bold flex items-center justify-center" style={{
                  backgroundColor: '#E8A020'
                }} data-id="element-2157" data-mp="dqfzhhmw5r45">
                    3
                  </span>
                  <span data-id="element-2158" data-mp="21lkt9yq9pbu0">
                    Click <RedBadge label="YOUR CLASS" data-id="element-2159" data-mp="1nonv1c7tks33" /> to begin
                  </span>
                </li>
              </ol>
            </div>
          </div>

          {/* Card 3 */}
          <div className="rounded-xl overflow-hidden border border-slate-200 shadow-sm" data-id="element-2160" data-mp="1dycmtdh3rwqe">
            <div className="px-4 py-3 flex items-center gap-2" style={{
            backgroundColor: '#2E7D32'
          }} data-id="element-2161" data-mp="1dwi66bcv6qs4">
              <PlayIcon className="h-4 w-4 text-white flex-shrink-0" data-id="element-2162" data-mp="14zhiy81j6yq9" />
              <p className="text-white text-xs font-bold leading-tight" data-id="element-2163" data-mp="19xsqgc4csx5b">
                SINGLE Class
                <span className="block font-normal text-green-100" data-id="element-2164" data-mp="v0s0oe5q3c9h">
                  One class at a time
                </span>
              </p>
            </div>
            <div className="bg-white px-4 py-4" data-id="element-2165" data-mp="gci52i9id834">
              <ol className="space-y-2 text-sm text-slate-700" data-id="element-2166" data-mp="gda1fvaxj9ug">
                <li className="flex gap-2" data-id="element-2167" data-mp="cbybfoo58mlq">
                  <span className="flex-shrink-0 w-5 h-5 rounded-full text-white text-xs font-bold flex items-center justify-center" style={{
                  backgroundColor: '#2E7D32'
                }} data-id="element-2168" data-mp="cczpm20ghp7o">
                    1
                  </span>
                  <span data-id="element-2169" data-mp="va0ulmu0fpbm">
                    Click <strong data-id="element-2170" data-mp="vau2ir4pgkvc">My Classes</strong> folder
                  </span>
                </li>
                <li className="flex gap-2" data-id="element-2171" data-mp="191p6bp0ckbs2">
                  <span className="flex-shrink-0 w-5 h-5 rounded-full text-white text-xs font-bold flex items-center justify-center" style={{
                  backgroundColor: '#2E7D32'
                }} data-id="element-2172" data-mp="193jr93bmc3w5">
                    2
                  </span>
                  <span data-id="element-2173" data-mp="1r8b4uwolzr74">
                    Click the class <strong data-id="element-2174" data-mp="1r9crzziwg457">Title</strong> to enter
                  </span>
                </li>
                <li className="flex gap-2" data-id="element-2175" data-mp="1mgjotg32x3v8">
                  <span className="flex-shrink-0 w-5 h-5 rounded-full text-white text-xs font-bold flex items-center justify-center" style={{
                  backgroundColor: '#2E7D32'
                }} data-id="element-2176" data-mp="1mfi4el06b50u">
                    3
                  </span>
                  <span data-id="element-2177" data-mp="258c64d8sd0n4">
                    Click <RedBadge label="YOUR CLASS" data-id="element-2178" data-mp="2595ipuufekd6" /> to begin
                  </span>
                </li>
              </ol>
            </div>
          </div>
        </div>
      </div>

      {/* 3. TIPS SECTION */}
      <div data-id="element-2179" data-mp="1w6mhff6agft1">
        <div className="flex items-center gap-2 mb-4" data-id="element-2180" data-mp="1w6wajbmmr32y">
          <LightbulbIcon className="h-5 w-5 text-yellow-500" data-id="element-2181" data-mp="prvaatqknyqk" />
          <h2 className="text-lg font-extrabold" style={{
          color: '#4A2D8F'
        }} data-id="element-2182" data-mp="pp9530r5lvbi">
            Pro Tips
          </h2>
        </div>

        <div className="space-y-3" data-id="element-2183" data-mp="2wdhsgb4gp92b">
          {/* Tip 1 */}
          <div className="flex gap-4 bg-white rounded-xl border border-slate-200 px-4 py-4 shadow-sm" data-id="element-2184" data-mp="31fqoxhgjmt96">
            <div className="flex-shrink-0 w-8 h-8 rounded-full text-white text-sm font-extrabold flex items-center justify-center" style={{
            backgroundColor: '#4A2D8F'
          }} data-id="element-2185" data-mp="35f7s248hzeb6">
              1
            </div>
            <div className="flex items-start gap-3" data-id="element-2186" data-mp="3k4nh9fsdrbor">
              <RefreshCwIcon className="h-4 w-4 text-purple-400 flex-shrink-0 mt-0.5" data-id="element-2187" data-mp="3k79pzir0bx8k" />
              <div className="text-sm text-slate-700" data-id="element-2188" data-mp="3p51h4ajtvfbp">
                <span className="font-bold text-slate-900" data-id="element-2189" data-mp="3t6d92mq6ccn2">
                  Pick up where you left off.
                </span>{' '}
                You don't have to finish in one sitting. When you log back in,
                you'll return to the section you were working in.{' '}
                <em data-id="element-2190" data-mp="322hrgumho1uk">
                  Click the last tab that is{' '}
                  <span className="text-blue-600 font-semibold" data-id="element-2191" data-mp="324u8n5kfa86k">blue</span> to
                  continue.
                </em>
              </div>
            </div>
          </div>

          {/* Tip 2 */}
          <div className="flex gap-4 bg-white rounded-xl border border-slate-200 px-4 py-4 shadow-sm" data-id="element-2192" data-mp="3b1bnojvwqq7l">
            <div className="flex-shrink-0 w-8 h-8 rounded-full text-white text-sm font-extrabold flex items-center justify-center" style={{
            backgroundColor: '#4A2D8F'
          }} data-id="element-2193" data-mp="374760k8x6xne">
              2
            </div>
            <div className="flex items-start gap-3" data-id="element-2194" data-mp="3uqm09p0cwv1h">
              <PauseIcon className="h-4 w-4 text-purple-400 flex-shrink-0 mt-0.5" data-id="element-2195" data-mp="3prsn5xozf61u" />
              <div className="text-sm text-slate-700" data-id="element-2196" data-mp="7mfx53stvd2l">
                <span className="font-bold text-slate-900" data-id="element-2197" data-mp="7n8y1o53v8ct">Need to pause?</span>{' '}
                Click the <RedBadge label="Leave/Pause Class" data-id="element-2198" data-mp="2p7e70zuv50a" /> button to stop
                the timer.
              </div>
            </div>
          </div>

          {/* Tip 3 */}
          <div className="flex gap-4 bg-white rounded-xl border border-slate-200 px-4 py-4 shadow-sm" data-id="element-2199" data-mp="r8r8pbr690g7">
            <div className="flex-shrink-0 w-8 h-8 rounded-full text-white text-sm font-extrabold flex items-center justify-center" style={{
            backgroundColor: '#4A2D8F'
          }} data-id="element-2200" data-mp="d7ojiq4vra12">
              3
            </div>
            <div className="flex items-start gap-3" data-id="element-2201" data-mp="8a55nrc3gz9n">
              <ClockIcon className="h-4 w-4 text-purple-400 flex-shrink-0 mt-0.5" data-id="element-2202" data-mp="8ay5s9gjsqit" />
              <div className="text-sm text-slate-700" data-id="element-2203" data-mp="3prpr38t56dji">
                <span className="font-bold text-slate-900" data-id="element-2204" data-mp="3uoy999eaihkr">
                  Slow reader? No problem.
                </span>{' '}
                If the timer reaches 0 before you finish a section,{' '}
                <strong data-id="element-2205" data-mp="3lp1hgywlt2lh">don't worry</strong> — there is no penalty. Take all the
                time you need.
              </div>
            </div>
          </div>

          {/* Tip 4 */}
          <div className="flex gap-4 bg-white rounded-xl border border-slate-200 px-4 py-4 shadow-sm" data-id="element-2206" data-mp="38p0qa81q0jl7">
            <div className="flex-shrink-0 w-8 h-8 rounded-full text-white text-sm font-extrabold flex items-center justify-center" style={{
            backgroundColor: '#4A2D8F'
          }} data-id="element-2207" data-mp="33xsifgg1h6a5">
              4
            </div>
            <div className="flex items-start gap-3" data-id="element-2208" data-mp="2uuzot6jdwih5">
              <TimerIcon className="h-4 w-4 text-purple-400 flex-shrink-0 mt-0.5" data-id="element-2209" data-mp="2px800le1dch6" />
              <div className="text-sm text-slate-700" data-id="element-2210" data-mp="2kyej0izjj3c9">
                <span className="font-bold text-slate-900" data-id="element-2211" data-mp="2l0zn7enb9vd6">
                  Stopping for the day?
                </span>{' '}
                Click the <RedBadge label="Leave/Pause Class" data-id="element-2212" data-mp="j8bcylc927nw" /> button to stop
                the timer before you close your browser.
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* 4. ADRE COMPLIANCE NOTE */}
      <div className="rounded-xl border-l-4 bg-purple-50 border-purple-400 px-5 py-5" data-id="element-2213" data-mp="1x3kvlod309jn">
        <div className="flex items-center gap-2 mb-2" data-id="element-2214" data-mp="221mnmyshjj79">
          <ClockIcon className="h-5 w-5" style={{
          color: '#4A2D8F'
        }} data-id="element-2215" data-mp="26twech1fcnal" />
          <h3 className="font-extrabold text-base" style={{
          color: '#4A2D8F'
        }} data-id="element-2216" data-mp="2aty35pm29m8g">
            About the 150-Minute Rule
          </h3>
        </div>
        <p className="text-sm text-slate-700 leading-relaxed" data-id="element-2217" data-mp="1j4ljfg6r9n4d">
          To comply with ADRE rules, all 3-hour CE classes are timed for a total
          of <strong data-id="element-2218" data-mp="1s4qbmj3doexy">150 minutes</strong>. Each section timer starts at 25
          minutes. As long as your class is open and your browser is connected,
          the timer counts down automatically. If you navigate away, close your
          browser, or shut down your computer, <strong data-id="element-2219" data-mp="33i2dwpjhopi0">the timer pauses</strong>{' '}
          — and picks up exactly where it left off when you return.
        </p>
      </div>
    </div>;
}